import { Controller } from '@hotwired/stimulus'

// Selects a read-only input's whole value on focus/click, so a human can copy
// it in one gesture. Replaces an inline onclick handler — inline handlers break
// the moment a Content-Security-Policy lands (likely on the OAuth/MCP surface).
export default class extends Controller {
  select() {
    this.element.select()
  }
}
